import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { getSaga } from "src/request/get";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getContactListSaga = createAction(
  "GET_CONTACT",
  ({ payload, params }: SagaActionParams<Type.ContactDto[]>) => ({
    payload,
    url: "/api/admin/contacts" + (params ? params : ""),
  })
);

const contactsSaga = [
  takeLatest<any>(
    getContactListSaga.toString(),
    (payload: SagaGenericParams<Type.ContactDto[]>) =>
      getSaga<Type.ContactDto[]>(payload)
  ),
];

export default contactsSaga;
